import { En, type TranslateDictionary } from 'media-chrome/dist/lang/en.js'
import { isPlainObject, isString } from 'remeda'

// Public types ----------------------------------------------------------------

export type AudioI18nResult =
  | Readonly<{
      status: 'ready'
      locale: string
      translations: Readonly<Partial<TranslateDictionary>>
    }>
  | Readonly<{ status: 'invalid' }>

// Private functions -----------------------------------------------------------

// Accepts only vendor translation keys with backend-provided text values.
const isTranslationDictionary = (
  value: unknown
): value is Readonly<Partial<TranslateDictionary>> =>
  isPlainObject(value) &&
  Object.entries(value).every(
    ([key, label]) => Object.keys(En).includes(key) && isString(label)
  )

// Public functions ------------------------------------------------------------

// Validates the server's translation object without choosing labels or a locale.
export const parseAudioI18n = (encoded: string): AudioI18nResult => {
  let value: unknown

  try {
    value = JSON.parse(encoded)
  } catch {
    // Invalid JSON is rejected by the same contract as invalid object shapes.
  }

  return isPlainObject(value) &&
    isString(value.locale) &&
    value.locale.trim().length > 0 &&
    isTranslationDictionary(value.translations)
    ? {
        status: 'ready',
        locale: value.locale,
        translations: value.translations
      }
    : { status: 'invalid' }
}
